var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 158,
    viewBox: "0 0 168 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_2263)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8836 93.5C70.8313 93.5 74.1816 92.1058 76.9346 89.3173C79.6876 86.5023 81.0641 83.0632 81.0641 79C81.0641 74.9368 79.6876 71.511 76.9346 68.7225C74.1816 65.9075 70.8313 64.5 66.8836 64.5C62.936 64.5 59.5857 65.9075 56.8327 68.7225C54.1057 71.511 52.7422 74.9368 52.7422 79C52.7422 83.0632 54.1057 86.5023 56.8327 89.3173C59.5857 92.1058 62.936 93.5 66.8836 93.5ZM66.8836 88.1223C64.3904 88.1223 62.2997 87.2724 60.6115 85.5728C58.9234 83.8466 58.0793 81.6557 58.0793 79C58.0793 76.3443 58.9234 74.1534 60.6115 72.4272C62.2997 70.701 64.3904 69.8379 66.8836 69.8379C69.3769 69.8379 71.4676 70.701 73.1557 72.4272C74.8439 74.1534 75.688 76.3443 75.688 79C75.688 81.6557 74.8439 83.8466 73.1557 85.5728C71.4676 87.2724 69.3769 88.1223 66.8836 88.1223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4268 87.6841H39.8565L51.193 69.3997V65.0577H33.2727V70.3159H44.3365L33 88.5604V92.9423H51.4268V87.6841Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6727 65.0577C99.4126 65.0577 102.529 66.3988 105.022 69.081C107.542 71.7633 108.801 75.0696 108.801 79C108.801 82.9304 107.542 86.2367 105.022 88.919C102.529 91.6012 99.4126 92.9423 95.6727 92.9423H84.8426V65.0577H95.6727ZM95.6727 87.6841C98.0361 87.6841 99.958 86.8874 101.438 85.294C102.919 83.674 103.659 81.576 103.659 79C103.659 76.424 102.919 74.3393 101.438 72.7459C99.958 71.1259 98.0361 70.3159 95.6727 70.3159H90.2187V87.6841H95.6727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.52 87.9231L129.156 92.9423H135L125.417 65.0577H118.755L109.21 92.9423H115.015L116.651 87.9231H127.52ZM122.105 71.3915L125.845 82.7843H118.365L122.105 71.3915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168 79C168 122.63 130.392 158 84 158C37.6081 158 0 122.63 0 79C0 35.3695 37.6081 0 84 0C130.392 0 168 35.3695 168 79ZM146 79C146 119.317 118.242 152 84 152C49.7583 152 22 119.317 22 79C22 38.6832 49.7583 6 84 6C118.242 6 146 38.6832 146 79Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_2263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 158,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo_black.2ad685829ead4d693c06611ae8a25616.svg";
export { ForwardRef as ReactComponent };